import React from 'react'
import '../../../../../sassFiles/customComponentSassfiles/singleApplicantBox.scss'
import { BsFillTelephoneFill } from 'react-icons/bs'
import { GrMail } from 'react-icons/gr'
const SingleApplicantBox = ({name,appliedfor,img,phone,mail}) => {
  return (
    <>
         <div className="singleApplicantBox">
            <div className="left">
                <div className="img">
                    <img src={img} alt="" />
                </div>
                <div className="text">                    
                        <h3>{name}</h3>
                        <h5>{appliedfor}</h5>                    
                </div>
            </div>
            <div className="right">
                <div className="circlebutton blue">
                    <p>CV</p>
                </div>
                <div className="circlebutton orange">
                    <a href={`tel:${phone}`}><BsFillTelephoneFill/></a>
                </div>
                <div className="circlebutton green">
                    <a href={`mailto:${mail}`}><GrMail/></a>
                </div>
            </div>
         </div>
    </>
  )
}

export default SingleApplicantBox